import { createRootRoute, createRoute, createRouter, Outlet } from "@tanstack/react-router";
import { AppCatalogPage, AppListingPage } from "@/features/store/app-view";
import { CatalogPage } from "@/features/store/catalog-page";
import { embedded } from "@/features/store/embed";
import { ListingPage } from "@/features/store/listing-page";

const rootRoute = createRootRoute({ component: () => <Outlet /> });

const catalogRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  component: embedded ? AppCatalogPage : CatalogPage,
});

const listingRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/$packageName",
  component: embedded ? AppListingPage : ListingPage,
});

export const router = createRouter({
  routeTree: rootRoute.addChildren([catalogRoute, listingRoute]),
  scrollRestoration: true,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
